import * as loggedInUserAction from 'actions/loggedInUser';

export const defaultState = {
  loggedInUserId: window.XM_CURRENT_USER_ID || '',
  // TODO: stuff like this that is injected from ondemand should be gradually removed
  // replacing with xm-api calls if required
  encryptedUserId: window.XM_ENCRYPTED_USER_ID || '',
  encryptedCompanyId: window.XM_ENCRYPTED_COMPANY_ID || '',
  customTimeZoneReverseMap: window.XM_CUSTOM_TIME_ZONE_MAP || {},
  isCompanyAdmin: window.XM_IS_COMPANY_ADMIN || false,
  isSuperAdmin: window.XM_IS_SUPER_ADMIN || false,
  isTemplateCompany: window.XM_IS_TEMPLATE || false,
  permissions: window.XM_PERMISSIONS,
  hasScheduledMessages: window.XM_HAS_SCHEDULED_MESSAGES || false,
  loggedInUserProfile: undefined,
  pricingUrl: '',
};

export default function loggedInUser(state = defaultState, action) {
  if (!action) {
    return state;
  }
  const { type, payload } = action;
  switch (type) {
    case loggedInUserAction.GET_PERSON_START:
      return {
        ...state,
        loggedInUserRequestStatus: 'LOADING',
      };
    case loggedInUserAction.GET_PERSON_SUCCESS:
      if (payload) {
        // Use standard time zones
        // Eg. "America/Denver" => America/Los_Angeles
        const userProfilePayload = {
          ...payload,
          customTimezone: payload.timezone,
        };
        if (
          state &&
          state.customTimeZoneReverseMap &&
          userProfilePayload.timezone &&
          state.customTimeZoneReverseMap[userProfilePayload.timezone]
        ) {
          userProfilePayload.timezone =
            state.customTimeZoneReverseMap[userProfilePayload.timezone];
        }
        return {
          ...state,
          loggedInUserRequestStatus: 'LOADED',
          loggedInUserProfile: {
            ...state.loggedInUserProfile,
            ...userProfilePayload,
          },
        };
      }
      return state;
    case loggedInUserAction.GET_PERMISSIONS_START:
      return state;
    case loggedInUserAction.GET_PERMISSIONS_SUCCESS:
      if (payload) {
        return {
          ...state,
          loggedInUserProfile: {
            ...state.loggedInUserProfile,
            permissions: payload.data,
          },
        };
      }
      return state;
    case loggedInUserAction.UPDATE_CUSTOM_TIME_ZONE_REVERSE_LOOKUP:
      if (payload && payload.customTimeZoneReverseMap) {
        return {
          ...state,
          customTimeZoneReverseMap: payload.customTimeZoneReverseMap,
        };
      }
      return state;
    case loggedInUserAction.UPDATE_HAS_SCHEDULED_MESSAGES:
      if (payload !== undefined) {
        return {
          ...state,
          hasScheduledMessages: !!payload,
        };
      }
      return state;
    case loggedInUserAction.UPDATE_LOGGED_IN_USER_ID:
      if (payload && payload.loggedInUserId) {
        return {
          ...state,
          loggedInUserId: payload.loggedInUserId,
        };
      }
      return state;
    case loggedInUserAction.UPDATE_USER_TIMEZONE:
      if (payload) {
        const { timezone } = payload;
        return {
          ...state,
          loggedInUserProfile: {
            ...state.loggedInUserProfile,
            timezone,
          },
        };
      }
      return state;
    case loggedInUserAction.UPDATE_PRICING_URL:
      if (payload) {
        return {
          ...state,
          pricingUrl: payload,
        };
      }
      return state;
    case loggedInUserAction.UPDATE_USER_PREFERENCES:
      if (payload) {
        const { permissions, ...userInfo } = payload;
        return {
          ...state,
          loggedInUserProfile: {
            ...state.loggedInUserProfile,
            permissions,
          },
          ...userInfo,
        };
      }
      return state;
    case loggedInUserAction.VIEWING_USER_PROFILE: {
      if (!payload || !state.loggedInUserProfile) {
        return state;
      }
      return {
        ...state,
        viewingLoggedInUserProfile:
          state.loggedInUserProfile.id === payload.viewingUserProfile,
      };
    }
    default:
      return state;
  }
}
